import MilestonesSerializer from './base';
import { isEmpty } from '@ember/utils';

export default class Milestone extends MilestonesSerializer {
  normalize(modelClass, payload) {
    if (isEmpty(payload.yearLevel)) {
      // Year 0 is a valid choice for year level milestones, but Go omits it because 0 is "empty".
      payload.yearLevel = 0;
    }
    return super.normalize(...arguments);
  }
}
